/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-sequences */
/* eslint-disable no-unused-expressions */
import React, { useEffect } from "react";

export default function Header()
{
  useEffect(() =>
  {
    require("../../assets/js/main.js")
  }, [])

  return (
    <>
      {/* -fix */}
      <header className="header -fix">
        <div className="container container-1400 ">
          <div className="sc-wrap d-flex ">
            <div className="logo__mb d-xl-none">
              <a href="/">
                <img src="images/logo.png" className="logo_mobile" alt="Logo" />
                <span>
                  Rocket Raccoon

                </span>
              </a>
            </div>
            <div className="header__right ms-auto d-none d-lg-flex align-items-center flex-grow-1">
              <a href="/" className="logo__">
                <img src="images/logo.png" alt="Logo" className="logo_" />
                <span>
                  Rocket Raccoon

                </span>
              </a>
              <nav className="main__nav ms-auto d-none d-xl-block">
                <button className="reset_btn  btn_dark btn_dark_small mr_r-10 " >Chart</button>
                <button className="reset_btn btn_dark btn_dark_small mr_r-10 ">Dapp</button>
                {/* <ul className="el__menu">

                  <li className="menu-item"><a href="#elements">Home</a></li>
                  <li className="menu-item"><a href="#features">Features</a></li>
                  <li className="menu-item"><a href="#nfts">NFTs</a></li>
                  <li className="menu-item"><a href="#tokenomics">Tokenomics</a></li>

                  <li className="menu-item "><a href="#roadmap">Roadmap</a></li>
              
                  <li className="menu-item "><a href="#" className="btn btn--primary">DOWNLOAD APP</a></li>
                </ul> */}
              </nav>
            </div>
            <div className="header-mb-btn ms-auto d-xl-none  hidden_des">
              {/* <div className="menu-mb__btn" data-id="menu-mobile">
                <span className="icon-bar" />
                <span className="icon-bar" />
                <span className="icon-bar" />
              </div> */}
              <button className="reset_btn  btn_dark btn_dark_small mr_r-10 " >Chart</button>
              <button className="reset_btn btn_dark btn_dark_small mr_r-10 ">Dapp</button>
            </div>
          </div>
        </div>
      </header>
      <div>
        {/* <nav id="menu-mobile" className="nav-mobile">
          <div className="nav-mobile__close icon-close js-menu__close" />
          <div className="nav-mobile__content">
            <ul className="nav-mobile--ul mb-4 text-center">
              <li className="menu-item "><a href="#elements">Elements</a></li>
              <li className="menu-item"><a href="#features">Features</a></li>
              <li className="menu-item"><a href="#nfts">NFTs</a></li>
              <li className="menu-item"><a href="#tokenomics">Tokenomics</a></li>
              <li className="menu-item"><a href="#roadmap">Roadmap</a></li>
     
              <li className="menu-item"><a href="#partners">Partners</a></li>
              <li className="menu-item"><a href="#">News</a></li>
              <li className="menu-item"><a href="#" className="btn btn--primary">DOWNLOAD APP</a></li>
            </ul>
          </div>
        </nav> */}

        <div className="sc-scrolltop d-none d-sm-block"><i className="icon-arrow-down -white mb-3" /></div>
      </div>
    </>
  );
}
